import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { FaTrashAlt } from 'react-icons/fa'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import {DEFAULT_HIDDEN_AMENITY_FOR_ROOM_TYPE, ROOM_TYPE_AMENITIES_CODES_MAX_OCCUPANCY, ROOM_TYPE_AMENITIES_MAX_OCCUPANCY} from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import StringConst from '../../../../constants/StringConst'
import { isArrayNotEmpty, isHotelDomestic, pad, searchFirstObjectInList, searchObjectListBoolean, sortObjectList } from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import SelectList from '../../../atoms/form/SelectList/SelectList'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import MeetingRoomsService from 'services/MeetingRoomsService'
import './MeetingRoom.scss'

class MeetingRoom extends Component {

  headers = ['Code', 'Description', 'Delete']

  constructor(props) {
    super(props)
    const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
    const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)

    if (!hotelCode || !hotelInfo) {
      this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
    }

    this.getInitialValues = this.getInitialValues.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleClearForm = this.handleClearForm.bind(this)
    this.resetFormData = this.resetFormData.bind(this)
    this.handleErrorModalCancel = this.handleErrorModalCancel.bind(this)

    // The individual meeting rooms which is being edited
    let meetingRoom = this.props.history.location?.state?.meetingRoom
    // The existing meeting rooms list
    let meetingRooms = this.props.history.location?.state?.meetingRooms

    if (meetingRooms === undefined) {
      this.props.history.replace(RouteConst.ROUTE_MEETING_ROOMS_PAGE)
    }
    const isDomestic = isHotelDomestic(hotelInfo)

    this.state = {
      hotelCode: hotelCode,
      hotelInfo: hotelInfo,
      isHotelDomestic: isDomestic,
      lengthUnit: getSessionItem(SessionConst.LENGTH_UNIT),
      areaUnits: getSessionItem(SessionConst.AREA_UNIT),
      capacityUnits: 'persons',
      capacityConversionFactor: isDomestic
        ? FormConst.meetingRoomCapacityConversionFactor.domestic
        : FormConst.meetingRoomCapacityConversionFactor.international,
      meetingRoom: meetingRoom,
      meetingRooms: meetingRooms,
      isEdit: this.props.history.location?.state?.isEdit,
      editIndex: this.props.history.location?.state?.editIndex,
      initialValues: meetingRoom ? this.getInitialValues(meetingRoom) : { ...this.initialValues },
      initialValuesForMeetingRoomAmenities: meetingRoom ? this.getMasterValuesForMeetingRoomAmenities(meetingRoom) : this.initialValuesForMeetingRoomAmenities,
      isLoading: false,
      showResetModal: false,
      showErrorModal: false
    }
  }

  initialValuesForMeetingRoomAmenities = {
    searchKey: '',
    categoryCode: '',
    selectedMeetingRoomAmenities: [],
    initialSelectedMeetingRoomAmenities: [],
    addIndices: [],
    removeIndices: [],
    optionsList: [],
    initialOptionsList: [],
    filteredList: undefined,
    filterOptions: [{ label: '', value: '' }]
  }

  initialValues = {
    name: '',
    length: 0,
    width: 0,
    height: 0,
    totalArea: 0,
    availableTotalArea: '',
    isBanquet: false,
    banquetCapacity: '0',
    isConference: false,
    conferenceCapacity: '0',
    isClassroom: false,
    classroomCapacity: '0',
    isReception: false,
    receptionCapacity: '0',
    isTheatre: false,
    theatreCapacity: '0',
    isUShape: false,
    uShapeCapacity: '0'
  }

  getMasterValuesForMeetingRoomAmenities = (meetingRoom) => {

    let initialValuesForMeetingRoomAmenities = {
        searchKey: '',
        categoryCode: '',
        selectedMeetingRoomAmenities: meetingRoom.meetingRoomAmenities || [],
        initialSelectedMeetingRoomAmenities: meetingRoom.meetingRoomAmenities || [],
        addIndices: [],
        removeIndices: [],
        optionsList: [],
        initialOptionsList: [],
        filteredList: undefined,
        filterOptions: [{ label: '', value: '' }]
    }
    return initialValuesForMeetingRoomAmenities
}

  validationSchema = Yup.object().shape({
    name: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
      .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
    length: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED),
    width: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED),
    height: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED),
    availableTotalArea: Yup.number().typeError(FormConst.VALIDATION_ERROR_TYPE_NUMBER)
        .min(0, FormConst.VALIDATION_ERROR_MINIMUM_VALUE_ZERO)
        .test("Available Total Area validation", function(val){
          var max = this.parent.length * this.parent.width;
          if(val > max) {
            return this.createError({ message: FormConst.VALIDATION_ERROR_MAX_AVAILABLE_TOTAL_AREA})
          }
          return true
        })
  })

  async componentDidMount() {
    let meetingRoomAmenities = []
    await MeetingRoomsService.getMeetingRoomAmenities({
        hotelCode: this.state.hotelCode
    }).then(async masterAmenitiesResponse => {
        meetingRoomAmenities = masterAmenitiesResponse.meetingRoomAmenities

        // Amenities already present on the meeting room
        // If there are no amenities, tag specific amenities will be used by default
        let selectedMeetingRoomAmenities = this.state.initialValuesForMeetingRoomAmenities.selectedMeetingRoomAmenities;
        let amenityCategories = {}

        if (isArrayNotEmpty(meetingRoomAmenities)) {
            // String to be used for padding
            const spaces = Array(10).join(StringConst.NBSP)

            meetingRoomAmenities.forEach((amenity, index) => {
                if(amenity.code === DEFAULT_HIDDEN_AMENITY_FOR_ROOM_TYPE) {
                    return;
                }
                // Set value to the index in this list so that it will be unique when used in any other list - unselected or selected
                amenity.value = index
                // Add a label to be used while displaying in the select list for unselected amenities
                amenity.label = pad(spaces, amenity.code, false) + amenity.description
                // Set amenityCode - property in outgoing request for code
                amenity.amenityCode = amenity.code
                // Add amenity category to filter options list
                if (amenity.amenityCategory) {
                    amenityCategories[amenity.amenityCategory.code] = amenity.amenityCategory.description
                }
            })

            // Calculate amenity categories list
            let amenityCategoriesList = [{ label: '', value: '' }]
            let categories = []

            // Get categories
            for (const key in amenityCategories) {
                if (amenityCategories.hasOwnProperty(key)) {
                    const element = amenityCategories[key]
                      categories.push({ label: element, value: key })
                }
            }

            // Add cateories
            if (isArrayNotEmpty(categories)) {
                sortObjectList(categories, 'label')
                amenityCategoriesList = [...amenityCategoriesList, ...categories]
            }

            // Get all options from master room amenities
            let options = meetingRoomAmenities.filter((amenity) => !searchObjectListBoolean('code', amenity.code, selectedMeetingRoomAmenities))
            options = sortObjectList(options, 'code')
            selectedMeetingRoomAmenities?.forEach(amenity => {
                let amenityInMaster = searchFirstObjectInList('code', amenity.code, meetingRoomAmenities)
                amenity.value = amenityInMaster.value
                amenity.label = amenityInMaster.label
                amenity.amenityCategory = amenityInMaster.amenityCategory
            })
            selectedMeetingRoomAmenities = sortObjectList(selectedMeetingRoomAmenities, 'amenityCode')

            this.setState({
                isLoading: false,
                // Master list of amenities
                meetingRoomAmenities: meetingRoomAmenities,
                initialValuesForMeetingRoomAmenities: {
                    ...this.state.initialValuesForMeetingRoomAmenities,
                    searchKey: '',
                    categoryCode: '',
                    // Selected room amenities
                    selectedMeetingRoomAmenities: selectedMeetingRoomAmenities,
                    initialSelectedMeetingRoomAmenities: selectedMeetingRoomAmenities,
                    // All possible options list
                    optionsList: options,
                    initialOptionsList: options,
                    // Used when a filter is applied to display filtered options
                    filteredList: undefined,
                    // Category filter options
                    filterOptions: amenityCategoriesList
                }
            })
        }

    }).catch(error => {
        this.setState({
            isLoading: false,
            showErrorModal: true,
            errorMessage: 'There was an error while retrieving Meeting Room Amenities'
        })
    })
  }

  getInitialValues = (meetingRoom) => {

    const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
    const capacityConversionFactor = isHotelDomestic(hotelInfo) ? FormConst.meetingRoomCapacityConversionFactor.domestic
                                                                : FormConst.meetingRoomCapacityConversionFactor.international
    let calculatedTotalArea = meetingRoom.dimension.length * meetingRoom.dimension.width
    let totalArea = Number(meetingRoom.dimension.area.value)
    let availableTotalArea = (totalArea != calculatedTotalArea) ? totalArea : ''

    let initialValues = {
      name: meetingRoom.name,
      length: meetingRoom.dimension.length,
      width: meetingRoom.dimension.width,
      height: meetingRoom.dimension.height,
      totalArea: calculatedTotalArea,
      availableTotalArea: availableTotalArea,
      isBanquet: false,
      banquetCapacity: (totalArea * capacityConversionFactor['BANQUET']).toFixed(),
      isConference: false,
      conferenceCapacity: (totalArea * capacityConversionFactor['CONFERENCE_BOARDROOM']).toFixed(),
      isClassroom: false,
      classroomCapacity: (totalArea * capacityConversionFactor['CLASSROOM']).toFixed(),
      isReception: false,
      receptionCapacity: (totalArea * capacityConversionFactor['RECEPTION']).toFixed(),
      isTheatre: false,
      theatreCapacity: (totalArea * capacityConversionFactor['THEATRE']).toFixed(),
      isUShape: false,
      uShapeCapacity: (totalArea * capacityConversionFactor['U_SHAPE']).toFixed(),
    }

    meetingRoom.configurations?.forEach((config) => {
      switch (config.code) {
        case `${FormConst.meetingRoomConfigurationCodes.BANQUET}`:
          initialValues.isBanquet = true
          initialValues.banquetCapacity = config.seatingCapacity
          break
        case `${FormConst.meetingRoomConfigurationCodes.CONFERENCE_BOARDROOM}`:
          initialValues.isConference = true
          initialValues.conferenceCapacity = config.seatingCapacity
          break
        case `${FormConst.meetingRoomConfigurationCodes.CLASSROOM}`:
          initialValues.isClassroom = true
          initialValues.classroomCapacity = config.seatingCapacity
          break
        case `${FormConst.meetingRoomConfigurationCodes.RECEPTION}`:
          initialValues.isReception = true
          initialValues.receptionCapacity = config.seatingCapacity
          break
        case `${FormConst.meetingRoomConfigurationCodes.THEATRE}`:
          initialValues.isTheatre = true
          initialValues.theatreCapacity = config.seatingCapacity
          break
        case `${FormConst.meetingRoomConfigurationCodes.U_SHAPE}`:
          initialValues.isUShape = true
          initialValues.uShapeCapacity = config.seatingCapacity
          break
      }
    })

    return initialValues
  }

  /**
   * Updates the initialValues and totalArea based on length and width
   * @param value the current value of the field
   * @param field the name of the field to match with the initial values
   */
  calculateConfigurationsCapacity = (value, field) => {
    let initialValues = {...this.state.initialValues}
    initialValues[field] = value
    initialValues.totalArea = initialValues.length * initialValues.width

    let totalArea = initialValues.availableTotalArea
                    ? Number(initialValues.availableTotalArea)
                    : initialValues.totalArea

    initialValues.banquetCapacity = (totalArea * this.state.capacityConversionFactor['BANQUET']).toFixed()
    initialValues.conferenceCapacity = (totalArea * this.state.capacityConversionFactor['CONFERENCE_BOARDROOM']).toFixed()
    initialValues.classroomCapacity = (totalArea * this.state.capacityConversionFactor['CLASSROOM']).toFixed()
    initialValues.receptionCapacity = (totalArea * this.state.capacityConversionFactor['RECEPTION']).toFixed()
    initialValues.theatreCapacity = (totalArea * this.state.capacityConversionFactor['THEATRE']).toFixed()
    initialValues.uShapeCapacity = (totalArea * this.state.capacityConversionFactor['U_SHAPE']).toFixed()
    this.setState({
                    initialValues : {...initialValues}
                  })
  }

  handleSubmit = (formData) => {
    let configurations = []

    if (formData.isBanquet) {
      configurations.push({ code: FormConst.meetingRoomConfigurationCodes.BANQUET,
                            seatingCapacity: formData.banquetCapacity})
    }

    if (formData.isConference) {
      configurations.push({ code: FormConst.meetingRoomConfigurationCodes.CONFERENCE_BOARDROOM,
                            seatingCapacity: formData.conferenceCapacity })
    }

    if (formData.isClassroom) {
      configurations.push({ code: FormConst.meetingRoomConfigurationCodes.CLASSROOM,
                            seatingCapacity: formData.classroomCapacity })
    }

    if (formData.isReception) {
      configurations.push({ code: FormConst.meetingRoomConfigurationCodes.RECEPTION,
                            seatingCapacity: formData.receptionCapacity  })
    }

    if (formData.isTheatre) {
      configurations.push({ code: FormConst.meetingRoomConfigurationCodes.THEATRE,
                            seatingCapacity: formData.theatreCapacity  })
    }

    if (formData.isUShape) {
      configurations.push({ code: FormConst.meetingRoomConfigurationCodes.U_SHAPE,
                            seatingCapacity: formData.uShapeCapacity  })
    }

    let meetingRoom = {
      name: formData.name.trim(),
      dimension: {
        length: new Number(formData.length),
        width: new Number(formData.width),
        height: new Number(formData.height),
        area: {
          value: new Number(formData.availableTotalArea ? formData.availableTotalArea : formData.totalArea)
        }
      },
      configurations: configurations,
      meetingRoomAmenities: [...this.state.initialValuesForMeetingRoomAmenities.selectedMeetingRoomAmenities]
    }

    let putData = [...this.state.meetingRooms]

    // Send only configuration code
    putData.forEach(meetingRoom => {
      if (meetingRoom.configurations) {
        meetingRoom.configurations = meetingRoom.configurations.map(configuration => {
          return {
            code: configuration.code,
            seatingCapacity: configuration.seatingCapacity
          }
        })
      }
    })

    // Update new meeting room in put data
    if (this.state.isEdit && this.state.editIndex > -1) {
      putData[this.state.editIndex] = meetingRoom
    } else {
      putData.push(meetingRoom)
    }

    this.props.onPut({ hotelCode: this.state.hotelCode, meetingRooms: putData })
    this.setState({ isLoading: true })
  }

  handleClearForm = () => {
    this.setState({ showResetModal: true })
  }

  resetFormData = (formikResetFormMethod) => {
    formikResetFormMethod()
    this.setState({
      showResetModal: false,
      initialValuesForMeetingRoomAmenities: {
        ...this.state.initialValuesForMeetingRoomAmenities,
        selectedMeetingRoomAmenities: [...this.state.initialValuesForMeetingRoomAmenities.initialSelectedMeetingRoomAmenities],
        optionsList: [...this.state.initialValuesForMeetingRoomAmenities.initialOptionsList],
        filteredList: undefined,
        searchKey: '',
        categoryCode: ''
      }
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.count !== this.props.count) {
      if (this.props.errorMessage) {
        this.setState({ isLoading: false, showErrorModal: true, errorMessage: this.props.errorDescription })
      } else {
        this.props.history.push(RouteConst.ROUTE_MEETING_ROOMS_PAGE)
        this.setState({ isLoading: false })
      }
    }
  }

  handleErrorModalCancel = () => {
    this.setState({ isLoading: false })
  }

  addAmenity = (valueList, selectedMeetingRoomAmenities) => {
    let values = valueList.map(index => {
        return Number(index)
    })

    let options = [...this.state.initialValuesForMeetingRoomAmenities.optionsList]
    let entriesToAdd = options.filter(option => values.includes(option.value))
    let remainingOptions = this.state.initialValuesForMeetingRoomAmenities.optionsList.filter(option => !values.includes(option.value))
    let fitleredList = this.state.initialValuesForMeetingRoomAmenities.filteredList?.filter(option => !values.includes(option.value))

    entriesToAdd.forEach(entry => {
        entry.chargable = 'false'
    })

    let selected
    if (isArrayNotEmpty(selectedMeetingRoomAmenities)) {
        selected = [...entriesToAdd, ...selectedMeetingRoomAmenities]
    } else {
        selected = [...entriesToAdd]
    }

    valueList.splice(0, valueList.length)

    let initialValuesForMeetingRoomAmenities = {
        ...this.state.initialValuesForMeetingRoomAmenities,
        optionsList: remainingOptions,
        selectedMeetingRoomAmenities: selected,
        addIndices: valueList,
        filteredList: fitleredList,
    }

    this.setState({
        initialValuesForMeetingRoomAmenities: initialValuesForMeetingRoomAmenities,
        minRoomAmenitiesLimitReached: false,
        initialValues: {
            ...this.state.initialValues
        }
    })
}

removeAmenity = (amenityCode, valueList, selectedMeetingRoomAmenities) => {
    if (this.props.onboardingStatus === FormConst.STATUS_COMPLETED) {
      return;
    }

    let values = valueList.map(index => {
        return Number(index)
    })

    let selected = [...selectedMeetingRoomAmenities]

    let entriesToRemove = selected.filter(option => values.includes(option.value))
    let remainingSelected = selected.filter(option => !values.includes(option.value))
    let options = [...entriesToRemove, ...this.state.initialValuesForMeetingRoomAmenities.optionsList]

    let initialValuesForMeetingRoomAmenities = {
        ...this.state.initialValuesForMeetingRoomAmenities,
        selectedMeetingRoomAmenities: remainingSelected,
        optionsList: options,
        filteredList: undefined,
        searchKey: '',
        categoryCode: ''
    }
    this.setState({
        initialValuesForMeetingRoomAmenities: initialValuesForMeetingRoomAmenities
    })
}

  searchOptions = (searchKey, categoryCode) => {
    let filteredList

    if (!searchKey && !categoryCode) {
        // If no filter is present, return undefined
        filteredList = undefined
    } else {
        filteredList = [...this.state.initialValuesForMeetingRoomAmenities.optionsList]
        // If category filter is present, first filter using the category code
        if (categoryCode) {
            filteredList = filteredList.filter(option => option.amenityCategory.code === categoryCode)
        }
        // If search key is present, filter the remaining list with the key
        if (searchKey) {
            filteredList =
                filteredList.filter(option => (option.code !== undefined && option.code.includes(searchKey))
                             || (option.amenityCode !== undefined && option.amenityCode.includes(searchKey))
                             || (option.description !== undefined && option.description.toUpperCase().includes(searchKey)))
        }
    }
    this.setState({
        initialValuesForMeetingRoomAmenities: {
            ...this.state.initialValuesForMeetingRoomAmenities,
            filteredList: filteredList,
            searchKey: searchKey,
            categoryCode: categoryCode
        }
    })
  }

  render() {

    return (
      <Formik
        initialValues={this.state.initialValues}
        validationSchema={this.validationSchema}
        enableReinitialize={true}
        onSubmit={(data, { setSubmitting }) => {
          setSubmitting(true)
          this.handleSubmit(data)
          setSubmitting(false)
        }}
      >
        {
          ({ values, errors, touched, dirty, isSubmitting, isValid, resetForm }) => (
            <Form className='meeting-rooms-form-element'>
              <div className='meeting-room-form-fields'>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_MEETING_ROOMS_PAGE}>Meeting Rooms</NavLink></li>
                    <li className="breadcrumb-item active" aria-current="page">Meeting Room</li>
                  </ol>
                </nav>
                <div className='meeting-room-type'>Meeting Room Details</div>
                <div className='form-helper-text'>
                  <br />
                    Please enter meeting room details.
                    </div>
                <div>
                  <TextInput id='name' name='name' type='text' label='Meeting Room Name' isrequired='true'
                    onChange={(e) => {
                      e.preventDefault();
                      this.calculateConfigurationsCapacity(e.target.value, 'name');
                    }}/>
                  <TextInput id='length' name='length' type='number' label='Length'
                    isrequired='true' min='0'
                    onChange={(e) => {
                      e.preventDefault();
                      this.calculateConfigurationsCapacity(e.target.value, 'length');
                    }}/>
                  <TextInput id='width' name='width' type='number' label='Width'
                    isrequired='true' min='0'
                    onChange={(e) => {
                      e.preventDefault();
                      this.calculateConfigurationsCapacity(e.target.value, 'width');
                    }}/>
                  <TextInput id='height' name='height' type='number' label='Height'
                    isrequired='true' min='0'
                    onChange={(e) => {
                        e.preventDefault();
                        this.calculateConfigurationsCapacity(e.target.value, 'height');
                    }}/>
                  <TextInput id='totalArea' name='totalArea' type='number' label='Calculated Total Area'
                    value={values.totalArea = values.length * values.width}
                    suffix={this.state.areaUnits}
                    disabled={true} />
                  <TextInput id='availableTotalArea' name='availableTotalArea' type='text' label='Available Total Area'
                    suffix={this.state.areaUnits}
                    onChange={(e) => {
                      e.preventDefault();
                      this.calculateConfigurationsCapacity(e.target.value, 'availableTotalArea');
                    }}/>

                  <hr />
                  <div className='meeting-room-type'><label>Configuration/Capacity</label></div>
                  <div className='form-helper-text'>
                    <br />
                      Here are your calculated capacities in number of persons.
                      <br />
                      Please select the configurations that are applicable.
                    </div>


                  <table id='configuration-table' className='table meeting-rooms-configuration-table'>
                    <thead>
                      <tr>
                        <th>Select</th>
                        <th>Configuration</th>
                        <th>Capacity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <TextInput
                            id='banquet-checkbox'
                            type='checkbox'
                            name='isBanquet'
                            value={values.isBanquet}
                            checked={values.isBanquet}
                          />
                        </td>
                        <td>Banquet</td>
                        <td><TextInput
                          id='banquet-capacity'
                          type='number'
                          name='banquetCapacity'
                          value={values.banquetCapacity}
                          placeholder='0'
                          suffix={this.state.capacityUnits}
                          title='Capacity'
                        /></td>
                      </tr>

                      <tr>
                        <td>
                          <TextInput
                            id='conferenceCheckbox'
                            type='checkbox'
                            name='isConference'
                            value={values.isConference}
                            checked={values.isConference}
                          />
                        </td>
                        <td>Conference / Boardroom</td>
                        <td>
                          <TextInput
                            id='conference-capacity'
                            type='number'
                            name='conferenceCapacity'
                            value={values.conferenceCapacity}
                            placeholder='0'
                            suffix={this.state.capacityUnits}
                            title='Capacity'
                          />
                        </td>
                      </tr>

                      <tr>
                        <td><TextInput
                          id='classroomCheckbox'
                          type='checkbox'
                          name='isClassroom'
                          value={values.isClassroom}
                          checked={values.isClassroom}
                        /></td>
                        <td>Classroom</td>
                        <td> <TextInput
                          id='classroom-capacity'
                          type='number'
                          name='classroomCapacity'
                          value={values.classroomCapacity}
                          placeholder='0'
                          suffix={this.state.capacityUnits}
                          title='Capacity'
                        /></td>
                      </tr>

                      <tr>
                        <td><TextInput
                          id='receptionCheckbox'
                          type='checkbox'
                          name='isReception'
                          value={values.isReception}
                          checked={values.isReception}
                        /></td>
                        <td>Reception</td>
                        <td><TextInput
                          id='reception-capacity'
                          type='number'
                          name='receptionCapacity'
                          value={values.receptionCapacity}
                          placeholder='0'
                          suffix={this.state.capacityUnits}
                          title='Capacity'
                        /></td>
                      </tr>

                      <tr>
                        <td><TextInput
                          id='theatreCheckbox'
                          type='checkbox'
                          name='isTheatre'
                          value={values.isTheatre}
                          checked={values.isTheatre}
                        /></td>
                        <td>Theatre</td>
                        <td> <TextInput
                          id='theatre-capacity'
                          type='number'
                          name='theatreCapacity'
                          value={values.theatreCapacity}
                          placeholder='0'
                          suffix={this.state.capacityUnits}
                          title='Capacity'
                        /></td>
                      </tr>

                      <tr>
                        <td><TextInput
                          id='uShape-checkbox'
                          type='checkbox'
                          name='isUShape'
                          value={values.isUShape}
                          checked={values.isUShape}
                        /></td>
                        <td>U-Shape</td>
                        <td><TextInput
                          id='uShape-capacity'
                          type='number'
                          name='uShapeCapacity'
                          value={values.uShapeCapacity}
                          placeholder='0'
                          suffix={this.state.capacityUnits}
                          title='Capacity'
                        /></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* Meeting Room Amenities */}

                <Formik
                      initialValues={this.state.initialValuesForMeetingRoomAmenities}
                      enableReinitialize={true}
                      onSubmit={(data, { setSubmitting }) => {
                          setSubmitting(true)
                          this.handleSubmit(data)
                          setSubmitting(false)
                      }}>
                        {
                          ({ values, errors, touched, dirty, isSubmitting, isValid, handleChange, resetForm }) => (
                            <div className='meeting-room-amenities'>
                                <p className='meeting-room-type'>Meeting Room Amenities</p>
                                <p className='helper-text'>{`Please select your meeting room amenities.`}</p>
                                <Row className='d-flex justify-content-start meeting-room-amenities-fields'>
                                  <Col xs={12} sm={12} xl={4}>
                                  <TextInput name='searchKey' id='search-key' placeholder='Search...' label='Search:' title='Search'
                                      onInput={(e) => {
                                          e.preventDefault()
                                          this.searchOptions(e.target.value.toUpperCase(), values.categoryCode)
                                      }
                                      } />
                                  <SelectInput name='categoryCode' id='filter-key' label='Filter by category:' title='Filter by category'
                                      options={values.filterOptions}
                                      onChange={(e) => {
                                          e.preventDefault()
                                          this.searchOptions(values.searchKey, e.target.value)
                                      }
                                      } />
                                      <SelectList
                                        name='addIndices'
                                        id='selected-input'
                                        label='Unselected amenities:'
                                        size='10'
                                        className='unselected-amenities'
                                        options={values.filteredList ? values.filteredList : values.optionsList}
                                        title='Unselected amenities' />
                                  </Col>
                                  <Col xs={12} sm={12} xl={1} className='text-center p-0 add-remove-buttons'>
                                    <Button name='Add >>' onClick={() => {
                                            this.addAmenity(values.addIndices, values.selectedMeetingRoomAmenities)
                                        }
                                        } />
                                  </Col>
                                  <Col xs={12} sm={12} xl={7} className='align-self-start'>
                                    <table className='table table-striped selected-amenities-table'>
                                      <caption>
                                          Selected Meeting Room Amenities
                                      </caption>
                                      <thead>
                                          <tr>
                                              {this.headers.map((header, index) => {
                                                  return <th key={header} index={`header-${index}`}>{header}</th>
                                              })
                                              }
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {values.selectedMeetingRoomAmenities.length > 0 ?
                                              values.selectedMeetingRoomAmenities.map((amenity, index) => {
                                                  return (
                                                      <tr key={index} className='align-items-center'>
                                                          <td>{amenity.code}</td>
                                                          <td>{amenity.description}</td>
                                                          <td>
                                                              <a onClick={() => {
                                                                  this.removeAmenity(amenity.code, [amenity.value], values.selectedMeetingRoomAmenities)
                                                              }}>
                                                                  <FaTrashAlt />
                                                              </a>
                                                          </td>
                                                      </tr>
                                                  )
                                              })
                                              : <tr>
                                                  <td colSpan='3' className='text-center'>
                                                      There are no selected amenities
                                                  </td>
                                              </tr>
                                          }
                                      </tbody>
                                    </table>
                                  </Col>
                                </Row>
                                <FormModal
                                    id='room-type-page-delete-modal'
                                    title='Delete All Amenities'
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h6>{FormConst.MODAL_DELETE_ACTION_TEXT}</h6>}
                                    proceed={() => {
                                        this.removeAmenity('', values.selectedMeetingRoomAmenities.map(amenity => amenity.value),
                                            values.selectedMeetingRoomAmenities)
                                        this.setState({ showDeleteModal: false })
                                    }}
                                    cancel={() => { this.setState({ showDeleteModal: false }) }}
                                    show={this.state.showDeleteModal} />
                            </div>
                          )
                        }
                  </Formik>
              </div>
              <FormFooter
                form={SideNavEntryMapping.MEETING_ROOMS}
                isSubmit
                submitName={FormConst.SAVE_BUTTON_TEXT}
                resetName={FormConst.RESET_BUTTON_TEXT}
                onReset={this.handleClearForm}
                submitDisabled={isSubmitting} />
              <FormModal
                id='meeting-room-page-save-modal'
                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                hotelInfo={this.state.hotelInfo}
                body={<h5>{FormConst.MODAL_UPDATE_ACTION_TEXT}</h5>}
                show={this.state.isLoading}
                isLoadingIndicator
              />
              <FormModal
                id='meeting-room-page-reset-modal'
                hotelInfo={this.state.hotelInfo}
                title={FormConst.MODAL_RESET_ACTION_TITLE}
                body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                proceed={() => {
                  this.resetFormData(resetForm)
                }}
                cancel={() => { this.setState({ showResetModal: false }) }}
                show={this.state.showResetModal}
              />
              <FormModal
                id='meeting-room-page-error-modal'
                hotelInfo={this.state.hotelInfo}
                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                body={<h5>{this.state.errorMessage}</h5>}
                isError
                cancel={() => { this.setState({ showErrorModal: false }) }}
                show={this.state.showErrorModal}
              />
            </Form>
          )}
      </Formik>
    )
  }
}

// Sample redux dispatch
const mapStateToProps = state => {
  return {
    meetingRoomsResponse: state.reducer.response,
    errorMessage: state.reducer.errorMessage,
    errorDescription: state.reducer.errorDescription,
    count: state.reducer.count
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_MEETING_ROOMS_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
    onPut: (data) => dispatch(asyncMethod(FormConst.FORM_MEETING_ROOMS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(MeetingRoom, SideNavEntryMapping.MEETING_ROOMS))